var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { class: [_vm.links - _vm.col + "__link-item", _vm.activeClass] },
    [
      _c("router-link", { attrs: { to: _vm.item.url } }, [
        _c("div", { class: _vm.links - _vm.col + "__link-icon" }, [
          _c("i", { staticClass: "fa", class: _vm.item.icon })
        ]),
        _vm._v(" "),
        _c("p", { class: _vm.links - _vm.col + "__link" }, [
          _vm._v(_vm._s(_vm.item.title))
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }